import React from 'react';
import { Row, Col } from 'reactstrap';

const DidYouKnow = ({ didYouKnow, didYouKnowImage }: any) => {
  return (
    <div
      className="py-5 my-5 didyouknow"
      style={{
        backgroundColor: 'rgb(255,182,193)',
      }}
    >
      <Row className="px-3">
        <Col md="6" className="pt-2 my-3">
          <h1>Did You Know?</h1>
          <p style={{ fontSize: 18 }}>{didYouKnow}</p>
        </Col>
        <Col className="text-center my-3" md="6">
          <img
            style={{ maxHeight: 300 }}
            className="img-fluid"
            src={didYouKnowImage}
            alt={didYouKnow}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DidYouKnow;
